import {Component, Input, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'app-workspace-solutions',
  templateUrl: './workspace-solutions.component.html',
  styleUrl: './workspace-solutions.component.scss'
})
export class WorkspaceSolutionsComponent implements OnInit, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  solutions: any[] = [];
  state: 'loading' | 'error' | 'empty' | 'ready' = 'loading';

  ngOnInit(): void {
    // Rendered from the model already on the link, with no fetch: until it is there, the view shows the shimmer.
    if (!this.magicLinkModel) {
      return;
    }
    const workspace = this.magicLinkModel.tabBar?.tabs?.[0]?.tabData?.WorkspaceModel;
    const solutions = workspace?.solutions;
    if (!workspace || typeof workspace !== 'object' || (solutions != null && !Array.isArray(solutions))) {
      this.state = 'error';
      return;
    }
    this.solutions = solutions ?? [];
    this.state = this.solutions.length ? 'ready' : 'empty';
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

}
